import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=062fb37e&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=062fb37e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062fb37e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('062fb37e')) {
      api.createRecord('062fb37e', component.options)
    } else {
      api.reload('062fb37e', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=062fb37e&scoped=true&", function () {
      api.rerender('062fb37e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Amrg0iQ1HBnw/JS/comp/CookieBox.vue"
export default component.exports